import sliceCreator from '../../index.jsx';
import { UPDATE_FARMER_COMMITMENT} from '../../../constants/index.jsx';
const _updateFarmerCommitmentAction = sliceCreator('UPDATE_FARMER_COMMITMENT', UPDATE_FARMER_COMMITMENT, 'put');

const { asyncAction: updateFarmerCommitmentAction, reducer, clearData: clearUpdateFarmerCommitmentAction } = _updateFarmerCommitmentAction;

export default reducer;

export {
    updateFarmerCommitmentAction,
    clearUpdateFarmerCommitmentAction
}